module.exports = __webpack_public_path__ + "static/media/mlogImage.c330ef28.png";